export default "__VITE_ASSET__Cb0l6pjP__"